import { Phone, Mail, Instagram, Globe, MapPin } from "lucide-react";
import { COMPANY } from "@/data/services";

export default function Footer() {
  return (
    <footer id="contacto" className="bg-[#0A192F] text-white">
      <div className="container mx-auto px-4 md:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10">
          <div className="md:col-span-5">
            <div className="flex items-center gap-3 mb-5">
              <img
                src={COMPANY.logo}
                alt={COMPANY.name}
                className="w-14 h-14 rounded-lg object-contain bg-white p-1"
                data-testid="footer-logo-img"
              />
              <div>
                <div className="font-display font-semibold text-lg">{COMPANY.name}</div>
                <div className="text-[11px] uppercase tracking-[0.2em] text-blue-200/80">{COMPANY.area}</div>
              </div>
            </div>
            <p className="text-slate-300 text-sm leading-relaxed max-w-md">
              {COMPANY.tagline}. Equipo propio, personal asegurado, herramientas, garantía y trato directo con gerencia. Empresa S.L.U. legalmente registrada en Valencia.
            </p>
            <p className="text-slate-400 text-xs leading-relaxed max-w-md mt-3">
              Atendemos por WhatsApp, teléfono y visitas presenciales en obra. No disponemos de oficina física abierta al público — nuestro equipo se desplaza para valorar los trabajos directamente en la vivienda, local o comunidad.
            </p>
          </div>

          <div className="md:col-span-4">
            <div className="text-[11px] uppercase tracking-[0.2em] text-blue-200/80 font-semibold mb-4">Contacto directo</div>
            <ul className="space-y-3 text-sm">
              <li>
                <a href={`tel:+34${COMPANY.whatsapp}`} className="flex items-center gap-3 hover:text-blue-300 transition-colors" data-testid="footer-whatsapp">
                  <Phone className="w-4 h-4 text-[#004B87] bg-white/95 rounded p-0.5" /> WhatsApp · {COMPANY.whatsappFormatted}
                </a>
              </li>
              <li>
                <a href={`tel:+34${COMPANY.phone2}`} className="flex items-center gap-3 hover:text-blue-300 transition-colors text-slate-300">
                  <Phone className="w-4 h-4" /> Tel · {COMPANY.phone2Formatted}
                </a>
              </li>
              <li>
                <a href={`mailto:${COMPANY.email}`} className="flex items-center gap-3 hover:text-blue-300 transition-colors" data-testid="footer-email">
                  <Mail className="w-4 h-4" /> {COMPANY.email}
                </a>
              </li>
              <li>
                <a href={`https://instagram.com/${COMPANY.instagram}`} target="_blank" rel="noreferrer" className="flex items-center gap-3 hover:text-blue-300 transition-colors" data-testid="footer-instagram">
                  <Instagram className="w-4 h-4" /> @{COMPANY.instagram}
                </a>
              </li>
              <li>
                <a href={`https://${COMPANY.website}`} target="_blank" rel="noreferrer" className="flex items-center gap-3 hover:text-blue-300 transition-colors" data-testid="footer-website">
                  <Globe className="w-4 h-4" /> {COMPANY.website}
                </a>
              </li>
              <li className="flex items-center gap-3 text-slate-300">
                <MapPin className="w-4 h-4" /> {COMPANY.area}
              </li>
            </ul>
          </div>

          <div className="md:col-span-3">
            <div className="text-[11px] uppercase tracking-[0.2em] text-blue-200/80 font-semibold mb-4">Servicios</div>
            <ul className="space-y-2 text-sm text-slate-300">
              <li>Reformas integrales</li>
              <li>Demoliciones</li>
              <li>Pladur / Albañilería</li>
              <li>Alicatados y pavimentos</li>
              <li>Pintura interior y fachada</li>
              <li>Impermeabilizaciones</li>
            </ul>
          </div>
        </div>

        <div className="mt-12 pt-6 border-t border-white/10 text-[11px] text-slate-400 leading-relaxed">
          <p className="max-w-4xl">
            <strong className="text-slate-300">Datos de empresa:</strong> {COMPANY.name} · <strong className="text-slate-300">NIF/CIF:</strong> {COMPANY.nif} · Responsable: {COMPANY.responsable}. {COMPANY.actividad}
          </p>
          <p className="max-w-4xl mt-3">
            <strong className="text-slate-300">Aviso legal:</strong> Los precios mostrados son orientativos y no constituyen una oferta contractual cerrada. El presupuesto definitivo será válido únicamente tras revisión técnica, medición real y aceptación por escrito de {COMPANY.name}.
          </p>
        </div>
        <div className="mt-6 pt-4 border-t border-white/5 flex flex-col md:flex-row items-start md:items-center justify-between gap-3 text-xs text-slate-400">
          <div>© {new Date().getFullYear()} {COMPANY.name}. Todos los derechos reservados.</div>
          <div className="max-w-2xl md:text-right">
            Estimación orientativa · IVA no incluido · Presupuesto definitivo tras visita técnica.
          </div>
        </div>
      </div>
    </footer>
  );
}
